import { Box, Flex, Skeleton, SkeletonText, Stack } from '@chakra-ui/react';

import { keyframes } from '@emotion/react';

const waveAnimation = keyframes`
  0% { opacity: 0.5; }
  50% { opacity: 1; }
  100% { opacity: 0.5; }
`;

export default function AssignmentDataCardSkeleton() {
  return (
    <Box
      height="250px"
      border="1px solid"
      borderColor="neutral.100"
      backgroundColor="white"
      borderRadius={16}
      width="225px"
      marginRight={4}
      transition="box-shadow 400ms"
    >
      {/* Image area with shimmer */}
      <Box
        width="full"
        height="160px"
        backgroundColor="neutral.100"
        borderTopRadius={16}
        animation={`${waveAnimation} 2.5s ease-in-out infinite`}
      />

      {/* Text area */}
      <Stack padding={4} spacing={2}>
        <Skeleton
          height="12px"
          width="60px"
          borderRadius="4px"
          animation={`${waveAnimation} 2s ease-in-out infinite 0.3s`}
        />
        <Skeleton
          height="20px"
          width="90%"
          borderRadius="4px"
          animation={`${waveAnimation} 2s ease-in-out infinite 0.6s`}
        />
      </Stack>
    </Box>
  );
}
